module.exports = __webpack_public_path__ + "img/loungeimage.80802e81.png";